import styled from "@emotion/styled";
import { fontRobotoCondensed } from "@product/scmp-sdk";

import { BaseLink } from "~/components/common/base-link";

export const Container = styled.div`
  display: flex;
  flex-flow: column nowrap;
  gap: 6px;

  padding-block-start: 16px;
  padding-inline-end: 14px;

  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  line-height: 19px;
  border-block-start: 1px solid #e5e5e5;
`;

export const Title = styled.div`
  font-weight: 700;

  i {
    font-weight: 400;
  }
`;
export const Content = styled.div``;

export const Link = styled(BaseLink)`
  display: flex;
  gap: 3px;
  align-items: center;

  color: #4585ff;
`;
